/* ---- Cart-drawer.js ---- */
(() => {
  'use strict';

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.drawer = this.querySelector('ft-drawer');
      window.theme?.cart?.register(this.section);

      this.onAdded = (e) => {
        if (this.dataset.openOnAdd === 'false' || this.isCartPage) return;
        clearTimeout(this.openTimer);
        this.openTimer = setTimeout(() => this.open(e.detail?.opener), window.theme?.addedDelay ?? 700);
      };
      this.onUpdated = (e) => this.render(e.detail);

      document.addEventListener('cart:added', this.onAdded);
      document.addEventListener('cart:updated', this.onUpdated);

      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-cart-drawer-close]')) this.close();
      });

      this.addEventListener('change', async (e) => {
        const box = e.target.closest('[data-gift-wrap]');
        if (!box) return;
        const cart = window.theme?.cart;
        if (!cart) return;
        box.disabled = true;
        let ok;
        if (box.checked) ok = await cart.add([{ id: Number(box.dataset.variantId), quantity: 1 }], { opener: box });
        else if (box.dataset.key) ok = await cart.change({ id: box.dataset.key, quantity: 0 });
        if (!ok && box.isConnected) { box.checked = !box.checked; box.disabled = false; }
      });
    }

    disconnectedCallback() {
      clearTimeout(this.openTimer);
      document.removeEventListener('cart:added', this.onAdded);
      document.removeEventListener('cart:updated', this.onUpdated);
      window.theme?.cart?.unregister(this.section);
    }

    get isCartPage() { return this.hasAttribute('data-cart-page'); }

    open(trigger) {
      if (this.isCartPage) return;
      document.querySelector('ft-modal[open]')?.close?.();
      this.drawer?.open(trigger);
    }

    close() { this.drawer?.close(); }

    render({ sections }) {
      const html = sections?.[this.section];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const agreed = this.querySelector('[data-cart-terms]')?.checked;
      ['[data-cart-totals]', '[data-cart-actions]', '[data-cart-empty]', '[data-cart-upsell]'].forEach((selector) => {
        const fresh = doc.querySelector(selector);
        const current = this.querySelector(selector);
        if (fresh && current) current.replaceChildren(...fresh.childNodes);
        else if (!fresh && current) current.replaceChildren();
      });
      const count = doc.querySelector('cart-items')?.dataset.count || '0';
      this.toggleAttribute('data-empty', count === '0');
      if (agreed) {
        const box = this.querySelector('[data-cart-terms]');
        if (box) box.checked = true;
        this.querySelectorAll('[data-cart-checkout]').forEach((btn) => { btn.disabled = false; });
        this.querySelectorAll('[data-cart-accelerated]').forEach((el) => { el.inert = false; });
      }
      window.initLazyImages?.(this);
    }
  }

  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  const recommendationCache = new Map();

  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;
      const key = `${url}|${this.dataset.cacheKey || ''}`;
      if (recommendationCache.has(key)) { this.swap(recommendationCache.get(key)); return; }
      fetch(url)
        .then((response) => (response.ok ? response.text() : ''))
        .then((text) => {
          const ready = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-recommendations-ready]');
          const html = ready ? ready.innerHTML : '';
          recommendationCache.set(key, html);
          if (this.isConnected) this.swap(html);
        })
        .catch(() => {});
    }

    swap(html) {
      if (!html) return;
      this.innerHTML = html;
      window.initLazyImages?.(this);
    }
  }

  if (!customElements.get('cart-recommendations')) customElements.define('cart-recommendations', CartRecommendations);
})();
